export default __webpack_public_path__ + "53a7a9e4123b27d3a1050193fb0b3981.png";